import { get, post } from '@/api/request'

export default {

  storeConfig: (assetConfig, success, failure) => post(
    '/api/asset-config',
    assetConfig,
    response => success(response),
    error => failure(error)
  ),
  
  updateConfig: (assetConfig, success, failure) => post(
    `/api/asset-config/${assetConfig.id}`,
    assetConfig,
    response => success(response),
    error => failure(error)
  ),

  loadConfigList: (success, failure) => get(
    '/api/list/asset-configs',
    response => success(response),
    error => failure(error)
  ),

  save: (asset, success, failure) => post(
    `/api/company/${asset.company_id}/assets`,
    asset,
    response => success(response),
    error => failure(error)
  ),

  loadAssetList: (companyId, success, failure) => get(
    `/api/company/${companyId}/asset-list`,
    response => success(response),
    error => failure(error)
  )
  
}